import { Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

const useStyles = makeStyles()((theme) => ({
  bold: {
    fontWeight: 800,
  },
  marginT: {
    marginTop: theme.spacing(1),
  },
  underline: {
    borderBottom: 'solid',
  },
}))

function InformationBlock({ children, title }) {
  const { classes } = useStyles()

  return (
    <>
      <Typography
        className={classNames(
          classes.bold,
          classes.marginT,
          classes.borderBottom,
        )}
      >
        {title}
      </Typography>
      <Typography>{children}</Typography>
    </>
  )
}

InformationBlock.propTypes = {
  title: PropTypes.string.isRequired,
}

export default InformationBlock
